module.exports = __webpack_public_path__ + "static/media/plantI.0c3ea63d.png";